import React from "react";
import "./SearchSetting.scss";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const SearchSetting: React.FC = () => {
  return (
    <Input
      size="large"
      variant="filled"
      prefix={<SearchOutlined />}
      style={{ color: "#808080" }}
      placeholder="Search Settings"
    />
  );
};

export default SearchSetting;
